module.exports = __webpack_public_path__ + "img/apple.a48ab129.png";